import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { convertUnderScoreStrings, isObject, isSet } from "../../utils/commonUtils";
import FormInputs from "../../components/UI/FormInputs";
import WithRoutify from "../../hoc/WithRoutify";
import withReduxState from "../../hoc/wReduxState";
import Buttons from "../../components/UI/Buttons";
import OrganizationService from "../../services/OrganizationService";
import NotificationTemplateService from "../../services/NotificationTemplateService";

const AddNotificationTemplate = (props) => {
  const [validation, setValidation] = useState({});
  const [formData, setFormData] = useState({});
  const [organizationOption, setOrganizationOption] = useState([]);
  const {
    isOpen,
    addFormHandler,
    fetchList,
    modelTitle,
    activeEditId,
    Toast,
    Loader,
    formDataInEdit,
  } = props;
  useEffect(() => {
    fetchOrganization();
    if (activeEditId) {
      fetch()
    }else{      
      Loader(true)
      setFormData({...formDataInEdit})
      Loader(false)
    }
  }, []);

  const fetch = async () => {
    try {
        Loader(true)
        const res= await NotificationTemplateService.getById(null, activeEditId).then((response) => {
          setFormData({ ...formData, ...response });
        });
        Loader(false)
      } catch (err) {
        Loader(false)
        console.log(err);
      } 
  }

  const typeList = [
    { label: "Select type", value: "" },
    { label: "SMS", value: "sms" },
    { label: "Email", value: "email" },
  ];
  const NotificationList = [
    { label: "Select", value: "" },
    { label: "Send Questionare", value: "SEND_QUESTIONNAIRE" },
    { label: "Appointment Notification", value: "APPOINTMENT_NOTIFICATION_TEXT" },
    { label: "Self Registration", value: "SELF_REGISTRATION_TEXT" },
    { label: "Appointment Reminder", value: "APPOINTMENT_REMAINDER_TEXT" },
    { label: "Lab result employer", value: "LAB_RESULT_EMPLOYER_TEXT" },
    { label: "Lab result Employee", value: "LAB_RESULT_PATIENT_TEXT" },
    { label: "Drug Screen result employer", value: "DRUG_SCREEN_RESULT_EMPLOYER_TEXT" },
    { label: "Drug Screen result Employee", value: "DRUG_SCREEN_RESULT_PATIENT_TEXT" },
    { label: "Physical result employer", value: "PHYSICAL_RESULT_EMPLOYER" },
    { label: "Scheduler notification company", value: "SCHEDULER_NOTIFICATION_COMPANY" },
    { label: "Chart Notes", value: "CHART_NOTES_EMAIL" },
  ];
    
    

  const inputFields = [
      {
      type: "TextInput",
      label: "Notification Name",
      placeholder: "Notification Name",
      className: "form-control form-control-solid",
      name: "notification_name",
      required: true,
    },
     {
      type: "SelectSearchList",
      label: "Notification type",
      placeholder: "select type",
      className: "form-control form-control-solid",
      name: "notification_type",
      options: typeList,
      value: formData.notification_type,
      required: true,
    },
    {
      type: "SelectSearchList",
      label: "Notification List",
      placeholder: "select",
      className: "form-control form-control-solid",
      name: "notification_list_type",
      options:  NotificationList ,
      value: formData.notification_list_type,
      required: true,
    },
    // {
    //   type: "TextInput",
    //   label: "Subject",
    //   placeholder: "subject",
    //   className: "form-control form-control-solid",
    //   name: "subject",
    //   required: true,
    // },
     {
      type: "Editor",
      label: `Body${formData.body ? ` (${formData.body.replace(/<[^>]*>/g, '').length} characters)` : ' (0 characters)'}`,
      placeholder: "Body",
      className: "form-control form-control-solid",
      name: "body",
      required: true,
    },
    
  ];
  

  if (isSet(props.profile.is_multiple_organization, false) === true && !activeEditId) {
        inputFields.unshift({
            type: "SelectSearchList",
            label: "Organization",
            placeholder: "Select Organization",
            className: "form-control form-control-solid",
            name: "organization_id",
            options: organizationOption || [],
            value: formData.organization_id,
            required: true,
        });
   }

    if (formData.notification_type === 'email' && !activeEditId) {
        inputFields.splice(4,0,{
            type: "TextInput",
            label: "Subject",
            placeholder: "subject",
            className: "form-control form-control-solid",
            name: "subject",
            required: true,
        });
    }    
     if (formData.notification_type === 'email' && activeEditId) {
        inputFields.splice(3,0,{
            type: "TextInput",
            label: "Subject",
            placeholder: "subject",
            className: "form-control form-control-solid",
            name: "subject",
            required: true,
        });
    }

const  fetchOrganization = async () => {
    if (props.profile.is_multiple_organization === true) {
      let org = await OrganizationService.getOrganization();
      let orgOpt = [{ label: "-Select Organization-", value: "" }];
      isSet(org.data.data,[]).forEach((itm) => {
        orgOpt.push({
          label: convertUnderScoreStrings(itm.name),
          value: itm.organization_uuid,
        });
      });
      setOrganizationOption(orgOpt);
    }
  };

  const changeHandler = (val, fieldName, e) => {
    setFormData(prev => ({
    ...prev,
    ...(fieldName === 'notification_type' && { subject: '' }),
    [fieldName]: val,
  }));
    setValidation({ ...validation, [fieldName]: "" });
  };
  const formSubmitHandler = async () => {
    try{
    const payload = {   
        ...formData,
    };
    let updateValidation = { ...validation };
    let data = null;
    if (activeEditId) {
      data = await NotificationTemplateService.updateTemplate(isSet(formData.organization_id, null),activeEditId, payload);
    } else {
      data = await NotificationTemplateService.createTemplate(isSet(formData.organization_id, null),payload);
    }
    console.log(data,"data111");
    
    if (data?.status && data?.status == "ERROR") {
      if (isObject(data.data)) {
        for (let key in data.data) {
          updateValidation = {
            ...updateValidation,
            [key]: data.data[key].join(","),
          };
        }
      } else {
        Toast.error(data.data);
      }
      if (Object.keys(updateValidation).length > 0) {
        setValidation(updateValidation);
      }
    }else if(data.code === 200 || data.code === 201){
      fetchList();
      addFormHandler();
      let message = `Template ${activeEditId ? "Update" : "Added"} Sucessfully`;
      Toast.success(message);
    }else{
      Toast.error('Something went wrong');
    }
}catch(err){
    console.log(err);
    Toast.error('Something went wrong');
}
  };
  return (
    <>
      <Modal
        show={isOpen}
        onHide={addFormHandler}
        size="lg"
        dialogClassName="hResponsive"
        contentClassName="h-100"
        backdrop="static"
        keyboard={false}
      >
        <div className="sh_modalBox">
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 className="font-weight-bold text-lg mb-0">{modelTitle}</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {inputFields &&
                inputFields.map((field, index) => (
                  <div className={`col-12  `} key={index}>
                    <div className="form-group">
                      <label className="text-gray-900 text-md opacity-75">
                        {" "}
                        {field.label}{" "}
                      </label>
                      <FormInputs
                        {...field}
                        changeHandler={(value, e) =>
                          changeHandler(value, field.name, e)
                        }
                        value={formData[field.name]}
                      />
                      {isSet(validation[field.name], "") !== "" ? (
                        <span className="text-danger m-1">
                          {isSet(validation[field.name], "")}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ))}
              <div className="col-12">
                {
                   formData.notification_type && formData.notification_list_type==='SELF_REGISTRATION_TEXT' ?
                   <div className="text-gray-900 text-md opacity-100">
                    Note: You can use placeholders in the body like {'{EMPLOYEE_NAME}'},{'{CLINIC_NAME}'},{'{CLINIC_ADDRESS}'},{'{LINK}'}.  depending on the notification type.
                  </div>
                   : formData.notification_type && formData.notification_list_type==='SCHEDULER_NOTIFICATION_COMPANY' ?
                   <div className="text-gray-900 text-md opacity-100">
                    Note: You can use placeholders in the body like {'{EMPLOYER_NAME}'},{'{EMPLOYEE_COUNT}'},{'{VISIT_LIST}'}.  depending on the notification type.
                  </div>
                  : formData.notification_type && formData.notification_list_type==='CHART_NOTES_EMAIL' ?
                   <div className="text-gray-900 text-md opacity-100">
                    Note: You can use placeholders in the body like  {'{EMPLOYEE_NAME}'},{'{EMPLOYER_NAME}'},{'{CLINIC_NAME}'},{'{CLINIC_ADDRESS}'},{'{VISIT_DATE}'},{'{VISIT_TIME}'}.  depending on the notification type.
                  </div>
                  :formData.notification_type && formData.notification_list_type!=='SELF_REGISTRATION_TEXT'?
                  <div className="text-gray-900 text-md opacity-100">
                    Note: You can use placeholders in the body like {'{EMPLOYEE_NAME}'},{'{EMPLOYER_NAME}'},{'{CLINIC_NAME}'},{'{CLINIC_ADDRESS}'},{'{VISIT_DATE}'},{'{VISIT_TIME}'},{'{LINK}'}.  depending on the notification type.
                  </div>
                  // : formData.notification_type === 'sms' ?
                  //   <div className="text-gray-900 text-md opacity-100">
                  //     Note: You can use placeholders in the body like {'{EMPLOYEE_NAME}'},{'{EMPLOYER_NAME}'},{'{CLINIC_NAME}'},{'{LINK}'}.  depending on the notification type.
                  //   </div>
                    :
                    <></>}
              </div>
            </div>
          </Modal.Body>

            <Modal.Footer className="d-flex justify-content-center">
              <Buttons
                clickHandler={() => formSubmitHandler()}
                className="btn btn-primary"
                acl={"any"}
                label={activeEditId ? "Update" : "Save"}
              />
              {/*
            <Buttons
                clickHandler={() => addFormHandler()}
                className="btn btn-outline-secondary rounded-pill"
                acl={"any"}
                label={"Cancel"}
              />
              */}
            </Modal.Footer>
          </div>
        </Modal>
      </>
    );
  };
  export default withReduxState(WithRoutify(AddNotificationTemplate));
